<section class="contact-section">
    <div class="contact-container">
        <div class="contact-headline">
            <h2 i18n>So erreichen Sie uns</h2>
            <p i18n>Direkte Kontaktwege für Ihr Anliegen.</p>
            <p i18n>Termine nach Vereinbarung</p>
        </div>

        <div class="contact-layout">
            <div class="contact-grid" aria-label="Kontaktdaten" i18n-aria-label>
                <article class="contact-card">
                    <h3 i18n><i class="fa-solid fa-map-location-dot" aria-hidden="true"></i> Adresse</h3>
                    <p i18n>
                        Brunnenwörthstr. 38<br>
                        72379 Hechingen<br>
                        Deutschland
                    </p>
                    <a href="https://maps.app.goo.gl/duQTins4nXrhpdbE6" target="_blank" rel="noopener noreferrer" i18n>
                        <i class="fa-solid fa-up-right-from-square" aria-hidden="true"></i> Google Maps
                    </a>
                </article>

                <article class="contact-card">
                    <h3 i18n><i class="fa-solid fa-user-large" aria-hidden="true"></i> Geschäftsführer</h3>
                    <p i18n>Maik Saliger, Freiberufler</p>
                    <p i18n>USt-IdNr.: DE439697844</p>
                </article>

                <article class="contact-card">
                    <h3 i18n><i class="fa-regular fa-envelope" aria-hidden="true"></i> E-Mail</h3>
                    <p><a href="mailto:m.saliger@albcode.de" i18n>m.saliger&#64;albcode.de</a></p>
                </article>

                <article class="contact-card">
                    <h3 i18n><i class="fa-regular fa-paper-plane" aria-hidden="true"></i> Kontaktformular/Ticketsystem</h3>
                    <p><a [routerLink]="['/ticketsystem']" routerLinkActive="router-link-active" i18n>Formular ausfüllen</a></p>
                </article>

                <article class="contact-card  mb-0">
                    <h3 i18n><i class="fa-solid fa-phone" aria-hidden="true"></i> Telefon</h3>
                    <p><a href="tel:+4974777904023">07477 7904023</a></p>
                </article>

                <article class="contact-card">
                    <h3 i18n><i class="fa-solid fa-mobile-screen-button" aria-hidden="true"></i> Mobil</h3>
                    <p><a href="tel:+491633860364">0163 3860364</a></p>
                </article>
            </div>

            <div class="contact-image-wrap">
                <img src="/freepics/man-holds-smartphone-works-laptop_vertical.jpg" alt="AlbCode Kontakt" i18n-alt />
            </div>
        </div>
    </div>
</section>